import React from "react";
import SidebarNavListItem from "./SidebarNavListItem";

const reduceChildRoutes = (props) => {
  const { items, page, depth } = props;

  items.push(
    <SidebarNavListItem
      depth={depth}
      href={page.href}
      icon={page.icon}
      key={page.title}
      badge={page.badge}
      title={page.title}
    />
  );

  return items;
};

export default reduceChildRoutes;
